<template>
  <material-card
    color="primary"
    height="100%"
    icon="mdi-palette"
  >
    <template #title>
      Change Colour Scheme
    </template>

    <v-card-text>
      <v-row
        class="ma-2"
      >
        <v-col
          justify="space-around"
          class="text-center"
        >
          <v-row
            class="mb-2 justify-center text-h5"
          >
            Primary
          </v-row>
          <v-row class="justify-space-around">
            <v-color-picker
              v-model="primary"
              hide-mode-switch
              hide-inputs
            />
          </v-row>
        </v-col>
        <v-col>
          <v-row
            class="mb-2 justify-center text-h5"
          >
            Secondary
          </v-row>
          <v-row class="justify-space-around">
            <v-color-picker
              v-model="secondary"
              hide-mode-switch
              hide-inputs
            />
          </v-row>
        </v-col>
      </v-row>
      <v-btn
        class="mt-2"
        block
        color="primary"
        @click="updateTheme()"
      >
        UPDATE
      </v-btn>
    </v-card-text>
    
  </material-card>
</template>

<script>
  export default {
    name: 'CustomColourCard',
    data () {
      return {
        primary: '',
        secondary: '',
      }
    },
    mounted () {
      this.primary = this.$vuetify.theme.themes.light.primary
      this.secondary = this.$vuetify.theme.themes.light.secondary
    },
    methods: {
      updateTheme: function () {
        this.$vuetify.theme.themes.dark.primary = this.primary
        this.$vuetify.theme.themes.dark.accent = this.primary
        this.$vuetify.theme.themes.dark.secondary = this.secondary
        this.$vuetify.theme.themes.light.primary = this.primary
        this.$vuetify.theme.themes.light.accent = this.primary
        this.$vuetify.theme.themes.light.secondary = this.secondary
        localStorage.setItem(
          'custom_primary',
          this.primary,
        )
        localStorage.setItem(
          'custom_secondary',
          this.secondary,
        )
      }
    }
  }
</script>